import { initArticle } from "@@components/post/dataArticle";

export { initArticle };
